import { render } from "./WeightsPage.vue?vue&type=template&id=fe4dd724&scoped=true"
import script from "./WeightsPage.vue?vue&type=script&lang=js"
export * from "./WeightsPage.vue?vue&type=script&lang=js"

import "./WeightsPage.vue?vue&type=style&index=0&id=fe4dd724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4dd724"]])

export default __exports__